/* eslint react/no-multi-comp: 0 */
import PropTypes from 'prop-types';

import React from 'react';
import ShoppingSearch from '../../search';
import ProductListDesktopFilterBar from './filter_bar';
import ProductListHeroImage from '../hero_image';
import ProductListNavigationCategories from '../navigation_categories';
import ShoppingBreadcrumbsBar from '../../breadcrumbs_bar';
import ProductListHeroContent from './../hero_content';
import { SHOPPING_CATEGORY_COLLECTIONS } from '../../../../constants';
import {isEmpty} from 'lodash';
import classNames from 'classnames';

const ProductListDesktopNavigation = (props, context) => {
  const { productList: { isShoppingHome, isShoppingCollectionPageHome, heroImage, logoImage, breadcrumbs, resultCount,
    categoryType, campaignBrandingImage, description, isBrandOrRetailerPage,
    openerImages, featuredCollectionUrl, featuredCollectionName },
  shoppingNavigationItems: { categories, pageTitle } } = props;

  const { query: { q } } = context.location;
  const hasQueryParam = q && q.length > 0;

  const shoppingOrCollectionHome = isShoppingHome || isShoppingCollectionPageHome;

  let subtitle;
  if (
    description
    && description.length > 0
    && (categoryType === SHOPPING_CATEGORY_COLLECTIONS || isBrandOrRetailerPage)
  ) {
    subtitle = (
      <div className="subtitle">
        <div className="subtitle-inner">
          <h2 dangerouslySetInnerHTML={{ __html: description }} />
        </div>
      </div>
    );
  }

  let heroHtml;
  if (heroImage || !isEmpty(openerImages)) {
    heroHtml = (
      <ProductListHeroImage
        heroImage={heroImage}
        logoImage={logoImage}
        openerImages={openerImages}
        pageTitle={pageTitle}
        categoryType={categoryType}
        brandingBanner={campaignBrandingImage}
        featuredCollectionUrl={featuredCollectionUrl}
        featuredCollectionName={featuredCollectionName}
        isShoppingHome={isShoppingHome}
      />
    );
  } else if (!hasQueryParam) {
    heroHtml = (
      <div className="hero-wrapper">
        <ProductListHeroContent
          pageTitle={pageTitle}
          categoryType={categoryType}
        />
      </div>
    );
  }

  return (
    <div className={classNames('product-list-navigation', { 'collection-page': featuredCollectionName })}>
      {!isShoppingHome && <ShoppingBreadcrumbsBar breadcrumbs={breadcrumbs} />}
      {!isShoppingHome && heroHtml}
      {shoppingOrCollectionHome &&
        <div className={'shopping-nav shopping-home'}>
          <div className="nav-wrapper">
            <ProductListNavigationCategories categories={categories} />
          </div>
          <ShoppingSearch />
        </div>
      }
      {subtitle}
      {!shoppingOrCollectionHome &&
        <div>
          <div className="search-nav" aria-label="search bar" tabIndex="0">
            <ShoppingSearch resultCount={resultCount} searchTerm={q} />
          </div>
          <ProductListDesktopFilterBar {...props} />
        </div>
      }
    </div>
  );
};

ProductListDesktopNavigation.propTypes = {
  shoppingNavigationItems: PropTypes.shape({
    categories: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      path: PropTypes.string,
      is_active: PropTypes.bool,
      name: PropTypes.string
    }))
  }).isRequired,
  imageMap: PropTypes.object,
  productList: PropTypes.shape({
    isShoppingHome: PropTypes.bool,
    heroImage: PropTypes.string,
    logoImage: PropTypes.string,
    campaignBrandingImage: PropTypes.string,
    resultCount: PropTypes.number,
    breadcrumbs: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string.isRequired,
        path: PropTypes.string
      }).isRequired
    )
  })
};

ProductListDesktopNavigation.contextTypes = {
  location: PropTypes.object.isRequired
};

export default ProductListDesktopNavigation;
